import { ContactEmailCard } from '../components/contact-email-card';
import { NotificationSettingsForm } from '../components/notification-settings-form';
import { Card, PageHeader } from '../components/ui';

/**
 * Настройки заказчика: у него нет профиля, поэтому часовой пояс и запасная
 * почта задаются только здесь.
 */
export function CustomerSettingsPage() {
  return (
    <>
      <PageHeader eyebrow="Кабинет заказчика" title="Настройки" />
      <p className="page-lead">
        Выберите, когда бот пишет в чат и о чём напоминать. Настройка общая для всех ваших заказов у
        любых художников.
      </p>
      <Card>
        <NotificationSettingsForm showTimezone />
      </Card>

      <div className="section-heading">
        <h2>Связь</h2>
      </div>
      <ContactEmailCard role="customer" />
    </>
  );
}
